import { AnalyticsClient, AnalyticsEvent } from "@App/utils/analytics/interfaces";
import { posthog } from "@App/utils/analytics/setup/posthog";

export const PosthogClient: AnalyticsClient = {
  capture({ name, props }: AnalyticsEvent) {
    posthog?.capture(name, props);
  },
};
